export default __webpack_public_path__ + "static/media/icomoon.72fbf443.ttf";